<template class="pendencyBody">
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-row>
        <b-navbar-nav>
          <b-button @click="goBack" size="xxl" variant="light">
            <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
          </b-button>
        </b-navbar-nav>

        <b-col md="8">
          <h5 class="page-title mb-2">
            <b> {{ $route.name }} </b>
          </h5>
        </b-col>
      </b-row>

      <div class="mt-3">
        <!-- Search Form Input Start-->
        <b-row>
          <b-col md="8" class="my-1">
            <b-form-group>
              <b-input-group>
                <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                  placeholder="Type to Search Assignment" ref="search" />

                <b-input-group-append class="mr-1">
                  <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                </b-input-group-append>
              </b-input-group>

              <b-col md="3">
                <label v-if="activeUserPreference">
                  <b> Created User Filter</b>
                </label>
                <model-list-select v-if="activeUserPreference" :list="$store.getters['common/getAllUserList']"
                  id="addedUserFilter" @input="debounceSearch" v-model="Filter.userFilter" option-value="userId"
                  option-text="employeeName" placeholder="Select Created User"></model-list-select>
              </b-col>
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-button :pressed="activeButtonBranch" v-model="activeButtonBranch"
              :variant="activeButtonBranch ? 'success' : 'danger'" @click="BranchBtnFilter(activeButtonBranch)">Branch
              {{ activeButtonBranch ? " Filter On" : " Filter Off" }}</b-button>

            <!-- :PMC_USERID="$sessionsStorage.get('userId')" -->
            <userBasedClient v-if="$sessionsStorage.get('userId')"
              :PMC_title="'User Summary - ' + $sessionsStorage.get('employeeName')" :PMC_USERID="Filter.userFilter"
              :PMC_USERNAME="$sessionsStorage.get('nameUser')" :PMC_USERDESIG="$sessionsStorage.get('designation')"
              :PMC_BranchClientPre="$sessionsStorage.get('branchclientPre')"
              :PMC_TransportTypePre="$sessionsStorage.get('transportTypePre')"
              :PMC_UserEmpName="$sessionsStorage.get('employeeName')"
              :PMC_UserEmpCode="$sessionsStorage.get('employeeCode')" />
          </b-col>

          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ JOBList.length }} Entries</small>
            </h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12" class="my-1">
            <b-button class="pull-right mb-1" v-if="JOBList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('checkJobPendency', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
            <b-button class="pull-right mb-1" @click="closeAssignmentPendencyList" size="sm" variant="outline-info"
              style="font-size: 0.675rem">Close Assignment Pendency</b-button>
            <b-pagination limit="5" :total-rows="JOBList.length" :per-page="perPage" v-model="currentPage"
              class="my-0 pull-right" />
          </b-col>
        </b-row>

        <div class="col-md-12 row table-wrapper-scroll-x my-custom-scrollbar">
          <b-table show-empty stacked="md" responsive :fields="columnMain" :items="JOBList"
            class="table-background position-relative" :per-page="perPage" :current-page="currentPage" :filter="filter"
            @filtered="onFiltered">
            <template slot="SN" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="Branch" slot-scope="row1">
              <div v-if="row1.item && row1.item.NotificationAlert2 && row1.item.NotificationAlert2.length > 0">
                <div v-for="(item, index2) in row1.item.NotificationAlert2" :key="index2" class="status-alerts">
                  <span :class="{ 'alert alert-danger-text blink2': true }">
                    <strong>{{ item.title }}</strong>
                    <template v-if="item.message">
                      - <strong>{{ item.message }}<br>{{ item.conclusion }}</strong>
                    </template>
                  </span>
                  <br>
                </div>
              </div>
              <div v-else></div>
              <tr :class="{ blink: isBlinking(row1.item) }">
                <td>
                  <div :class="{ 'blink-circle': shouldBlink(row1.item) }"></div>
                </td>
              </tr>
              <span>{{ row1.item.Branch }}</span><br />
              <span>{{ "Prealert : " + row1.item.is_prealertSend }}</span><br />
              <span>{{ "Manifest : " + row1.item.is_manifestation_status }}</span><br />
              <span v-if="row1.item.JOBTYPE.includes('FF')">{{ "FF : " + row1.item.FFInvStatus }}<br /></span>
              <span v-if="row1.item.JOBTYPE.includes('CC')">{{ "CC : " + row1.item.CCInvStatus }}<br /></span>
              <span v-if="row1.item.JOBTYPE.includes('TPT')">{{ "TPT : " + row1.item.TPTInvStatus }}<br /></span>
              <span v-if="row1.item.noteSeries">{{ "Note Series : " + row1.item.noteSeries }}<br /></span>
              <!-- <span>{{ "Billing : " + row1.item.TallyBillingSeries }}</span> -->
              <span>Billing : </span>
              <div class="text-left" v-if="row1.item.TallyBillingSeries">
                <div v-if="row1.item.TallyBillingSeries">
                  <span v-for="(item1, index) in row1.item.TallyBillingSeries.split(',')" :key="index">
                    <b-badge variant="light"><b>{{ item1 == "" ? "-------" : item1 }}</b></b-badge><br />
                  </span>
                </div>
              </div>
              <div class="text-left" v-else>
                <b-badge variant="light">-------</b-badge>
              </div>
               <BookingTrack :containerArr="row1.item.freightContainers"
                :slineName="row1.item.shippingLine"
                :clientName="row1.item.clientName"
                :modal_title="`Container Movement Booking No: ${row1.item.BookingNo} Job No - ${row1.item.JOBNO} Client: ${row1.item.clientName}`"
                :JOBNO="row1.item.JOBNO" :shipment_id="Number(0)" :subscription_id="Number(0)" :fk_sub_track_id="Number(0)"
                :fk_all_module_id="Number(row1.item.allModuleId)" :fk_booking_id="Number(row1.item.fk_booking_id)"
                :fk_container_id="Number(0)" :booking_number="row1.item.BookingNo" :container_number="''" />
              <JobWisePaymentsDetails
                  v-if="row1.item.allModuleId"
                  :allModuleId="Number(row1.item.allModuleId)"
                  :JobNo="row1.item.JOBNO"
                  />
              <ContainerSummary v-if="row1.item.allModuleId"
                :PMC_title="'Container Summary Job No - ' + row1.item.JOBNO" :PMC_JOBID="row1.item.allModuleId"
                :PMC_JOBNO="row1.item.JOBNO" :PMC_JOBDATE="row1.item.JOBDate" :PMC_JOBTYPE="row1.item.JOBTYPE"
                :PMC_AgentType="''" :PMC_Client="row1.item.clientName" :PMC_Sline="row1.item.shippingLine" />
              <AssignmentSplitMergeSummary v-if="row1.item.allModuleId"
                :PMC_title="'Assignment Split/Merge/Move Summary Job No - ' + row1.item.JOBNO" :PMC_JOBID="row1.item.allModuleId"
                :PMC_JOBNO="row1.item.JOBNO" :PMC_JOBDATE="row1.item.JOBDate" :PMC_JOBTYPE="row1.item.JOBTYPE"
                :PMC_AgentType="''" :PMC_Client="row1.item.clientName" :PMC_Sline="row1.item.shippingLine" />
            </template>
            <template slot="BookingNo" slot-scope="row2">

              <span :style="row2.item.SubscriptionId?'color: blue;font-weight:bold':''"
                @click="row2.item.SubscriptionId?goToSubscriptionPage(row2.item):''">{{ row2.item.BookingNo
                }}</span><br />
              <span>{{ "Billing Type : " + row2.item.is_billingType_status }}<br /></span>
              <span v-if="
                  row2.item.is_billingType_status == 'Local' ||
                  row2.item.is_billingType_status == 'Both'
                ">{{
                "Local : " +
                (row2.item.billingTypeMain == "Local Billing" ? "Done" : "Pending")
                }}<br /></span>
              <span v-if="
                  row2.item.is_billingType_status == 'Overseas' ||
                  row2.item.is_billingType_status == 'Both'
                ">{{
                "Overseas : " +
                (row2.item.is_manifestation_status == "Yes" ? "Done" : "Pending")
                }}<br /></span>
              <span v-if="row2.item.blType">{{ "BL Type : " + row2.item.blType }}<br /></span>
              <span v-if="row2.item.frghtTermsHbl">{{ "Freight Terms Hbl : " + row2.item.frghtTermsHbl }}<br /></span>
              <span v-if="row2.item.frghtTermsMbl">{{ "Freight Terms Mbl : " + row2.item.frghtTermsMbl }}<br /></span>
              <span v-if="row2.item.frghtTermsLiner">{{ "Freight Terms Liner : " + row2.item.frghtTermsLiner
                }}<br /></span>
            </template>
            <template slot="JOBNO" slot-scope="row3">
              <tr :class="{ blink: isBlinking(row3.item) }" @click="goPage(row3.item)">
                <td>
                  <span>{{ "JOBNO : " + row3.item.JOBNO }}</span><br />
                </td>
              </tr>

              <span>{{ "JOBDate : " + row3.item.JOBDate }}</span><br />
              <span>{{ "RaisedBy : " + row3.item.RaisedBy }}</span><br />
              <span>{{ "MBLNO : " + row3.item.MBLNO }}</span><br />
              <span>{{ "HBLNO : " + row3.item.HBLNO }}</span><br />
              <span>{{ "Tot Cont : " + row3.item.ContainerCount }}</span><br />
              <div class="text-left" v-if="row3.item.freightContainers">
                <div v-if="row3.item.freightContainers">
                  <span v-for="(item1, index) in row3.item.freightContainers.split(',')" :key="index">
                    <h6>
                      <b-badge variant="light">{{ item1 == "" ? "-------" : item1 }}
                      </b-badge>
                    </h6>
                    <ContaierWebLogSummary
                          v-if="row3.item.allModuleId && item1"
                          :PMC_title="'Container Event Summary Job No - ' + row3.item.JOBNO"
                          :PMC_JOBID="row3.item.allModuleId"
                          :PMC_JOBNO="row3.item.JOBNO"
                          :PMC_CONTNO="item1"
                          :PMC_JOBDATE="''"
                          :PMC_JOBTYPE="''"
                          :PMC_AgentType="''"
                          :PMC_Client="''"
                          :PMC_Sline="''"
                        />
                  </span>
                </div>
              </div>
              <div class="text-left" v-else>
                <b-badge variant="light">-------</b-badge>
              </div>
              <!-- <span>{{ "Containers : " + row3.item.freightContainers }}</span><br /> -->
            </template>
            <template slot="clientName" slot-scope="row4">
              <span>{{ row4.item.clientName }}</span>
            </template>
            <template slot="shippingLine" slot-scope="row5">
              <span>{{ row5.item.shippingLine }}</span>
            </template>
            <template slot="POR" slot-scope="row6">
              <span>{{ "POR : " + row6.item.POR }}</span><br />
              <span>{{ "POL : " + row6.item.POL }}</span><br />
              <span>{{ "POD : " + row6.item.POD }}</span>
            </template>
            <template slot="vgmcut_off_date_est" slot-scope="row10">
              <!-- <span @click="goVGMPage(row10.item)">{{
                row10.item.VGM_submissionDate_actual +
                " / " +
                row10.item.vgmcut_off_date_est
              }}</span> -->
              <span :class="row10.item.VGM_submissionDate_actual == 'Pending' ? 'error' : ''"
                @click="goVGMPage(row10.item)">{{ row10.item.VGM_submissionDate_actual }}</span>/
              <span :class="row10.item.vgmcut_off_date_est == 'Pending' ? 'error' : ''"
                @click="goVGMPage(row10.item)">{{ row10.item.vgmcut_off_date_est }}</span>
              <!-- <span @click="goVGMPage(row10.item)">{{
                row10.item.VGM_submissionDate_actual +
                " / " +
                row10.item.vgmcut_off_date_est
              }}</span> -->
            </template>
            <template slot="si_cutoff_est" slot-scope="row11">
              <span :class="row11.item.SI_Submissiondate_actual == 'Pending' ? 'error' : ''"
                @click="goVGMPage(row11.item)">{{ row11.item.SI_Submissiondate_actual }}</span>/
              <span :class="row11.item.si_cutoff_est == 'Pending' ? 'error' : ''" @click="goVGMPage(row11.item)">{{
                row11.item.si_cutoff_est }}</span>
              <!-- <span @click="goVGMPage(row11.item)">{{
                row11.item.SI_Submissiondate_actual + " / " + row11.item.si_cutoff_est
              }}</span> -->
            </template>
            <template slot="tr_cutoff_date_est" slot-scope="row12">
              <span :class="row12.item.tr_Submissiondate_actual == 'Pending' ? 'error' : ''"
                @click="goVGMPage(row12.item)">{{ row12.item.tr_Submissiondate_actual }}</span>/
              <span :class="row12.item.tr_cutoff_date_est == 'Pending' ? 'error' : ''" @click="goVGMPage(row12.item)">{{
                row12.item.tr_cutoff_date_est }}</span>
              <!-- <span @click="goVGMPage(row12.item)">{{
                row12.item.tr_Submissiondate_actual +
                " / " +
                row12.item.tr_cutoff_date_est
              }}</span> -->
            </template>

            <template slot="handoverDate_actual" slot-scope="row12">
              <span :class="row12.item.handoverDate_actual == 'Pending' ? 'error' : ''">{{
                row12.item.handoverDate_actual
                }}</span>/
              <span :class="row12.item.handover_cutoff_date_est == 'Pending' ? 'error' : ''">{{
                row12.item.handover_cutoff_date_est }}</span>
              <!-- <span>{{
                row12.item.handoverDate_actual +
                " / " +
                row12.item.handover_cutoff_date_est
              }}</span> -->
            </template>
            <template slot="oe_payment_status" slot-scope="row13">
              <span>{{ "Payment Status : " + row13.item.oe_payment_status }}</span><br />

              <span :class="row13.item.oe_payment_date_first == 'Pending' ? 'error' : ''">{{ "Payment First Date : " +
                row13.item.oe_payment_date_first }}</span>
            </template>
            <template slot="SOB" slot-scope="row14">
              <span :class="row14.item.SOB == 'Pending' ? 'error' : ''">{{
                "P44 : " + row14.item.SOB
                }}</span><br />
              <span :class="row14.item.SysSOB == 'Pending' ? 'error' : ''">{{
                "Sys : " + row14.item.SysSOB
                }}</span>
            </template>
            <template slot="SysETA_actual" slot-scope="row15">
              <span :class="row15.item.ETA_estimated == 'Pending' ? 'error' : ''">{{
                "OF ETA Estimated : " + row15.item.ETA_estimated
                }}</span><br />
              <span :class="row15.item.ETA_actual == 'Pending' ? 'error' : ''">{{
                "OF ETA Actual : " + row15.item.ETA_actual
                }}</span><br />
              <span :class="row15.item.SysETA_estimated == 'Pending' ? 'error' : ''">{{
                "Sys ETA Estimated : " + row15.item.SysETA_estimated
                }}</span><br />
              <span :class="row15.item.SysETA_actual == 'Pending' ? 'error' : ''">{{
                "Sys ETA Actual : " + row15.item.SysETA_actual
                }}</span>
            </template>
          </b-table>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  lastVisitPage,
  globalPermissionStatus,
  GlobalContainerValid,
  GlobalGetLocation,
} from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
import DateRangePicker from "vue2-daterange-picker";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import ContaierWebLogSummary from "../common/moduleBasedContaierWebLogSummary.vue";
import AssignmentSplitMergeSummary from "../common/AssignmentSplitMergeSummary.vue";
import userBasedClient from "../common/userBasedClient.vue";
import CustomLoader from "../common/customLoader.vue";
import BookingTrack from "../consoleBooking/bookingTrack.vue";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", this.$route.path);
      if (globalPermissionStatus("Sea Freight")) {
        if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
          this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
        } else {
          this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
        }
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }

      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      );
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },

  data() {
    return {
      isLoading: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 50,
      pageOptions: [100, 200, 300],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      docURL: URL_BASE_DOC,
      ExcelBtnName: "Export As Excel",
      activeButtonBranch:
        this.$sessionsStorage.get("branchclientPre") == "1" ? true : false,
      activeUserPreference: this.$sessionsStorage.get("user_pre") === "1" ? true : false,

      Filter: {
        userFilter: this.$sessionsStorage.get("userId"),
      },

      columnMain: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "HJ.",
        },
        {
          key: "Branch",
          mainkey: "Branch",
          label: "Branch",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "BookingNo",
          mainkey: "BookingNo",
          label: "Booking No",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "JOBNO",
          lmainkey: "JOBNO",
          label: "JOB Details",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "shippingLine",
          lmainkey: "shippingLine",
          label: "Sline",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "POR",
          mainkey: "POR",
          label: "POR - POL - POD",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        // {
        //   key: "POL",
        //   mainkey: "POL",
        //   label: "POL",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "G.",
        // },
        // {
        //   key: "POD",
        //   mainkey: "POD",
        //   label: "POD",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "H.",
        // },
        // {
        //   key: "FPOD",
        //   mainkey: "FPOD",
        //   label: "FPOD",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "I.",
        // },
        {
          key: "vgmcut_off_date_est",
          mainkey: "vgmcut_off_date_est",
          label: "VGM Date/Cutoff",
          sortable: true,
          sortDirection: "ASC",
          table: "J.",
        },
        {
          key: "si_cutoff_est",
          mainkey: "si_cutoff_est",
          label: "SI Date/Cutoff",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "tr_cutoff_date_est",
          mainkey: "tr_cutoff_date_est",
          label: "TR Date/CutOFF",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },
        {
          key: "handoverDate_actual",
          mainkey: "handoverDate_actual",
          label: "Handover Date/CutOFF",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },

        {
          key: "oe_payment_status",
          mainkey: "oe_payment_status",
          label: "Sline Payment Date",
          sortable: true,
          sortDirection: "ASC",
          table: "M.",
        },
        {
          key: "SOB",
          mainkey: "SOB",
          label: "SOB",
          sortable: true,
          sortDirection: "ASC",
          table: "N.",
        },
        {
          key: "SysETA_actual",
          mainkey: "SysETA_actual",
          label: "ETA Destination(Actual, Estimated)",
          sortable: true,
          sortDirection: "ASC",
          table: "O.",
        },
      ],
      JOBList: [],
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
    };
  },

  mounted() {},
  filters: {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    Loading,
    ContainerSummary,
    JobWisePaymentsDetails,
    ContaierWebLogSummary,
    AssignmentSplitMergeSummary,
    userBasedClient,
    ModelListSelect,
    CustomLoader,
    BookingTrack,
  },

  created() {},

  computed: {},

  watch: {},

  methods: {
    goToSubscriptionPage(item) {
      if (item.SubscriptionId) {
        this.$router.push({
          path: "/tracking/ocean-insights/subscription/" + item.SubscriptionId,
        });
      }
    },
    BranchBtnFilter(type) {
      this.activeButtonBranch = !type;

      this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
    },
    closeAssignmentPendencyList() {
      let payload = {};
      payload = {
        itemCode: "closeJobPendency",
        type:
          this.$route.path == "/conassignmentPendency"
            ? "con_job_pendency"
            : "fcl_job_pendency",
        user_id: this.$sessionsStorage.get("userId"),
      };

      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data.JOBPendencyFLAG == 1) {
            localStorage.setItem("fcl_job_pendency", data.fcl_job_pendency);
            localStorage.setItem("con_job_pendency", data.con_job_pendency);
            this.$sessionsStorage.set("fcl_job_pendency", data.fcl_job_pendency);
            this.$sessionsStorage.set("con_job_pendency", data.con_job_pendency);
            if (this.$route.path == "/conassignmentPendency") {
              this.$router.push({
                path: "/ffExportCon/viewFFConsoExport",
              });
            } else if (this.$route.path == "/fclassignmentPendency") {
              this.$router.push({
                path: "/freightForward/ViewffExportFcl",
              });
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on JOBList Error: ", error);
        });
    },
    goVGMPage(item) {
      if (item.isConsolidation == "0") {
        if (item.newContainerFlow == "1") {
          this.$sessionsStorage.set("editExportFCLId", item.ffExportFclId);
          this.$sessionsStorage.set("editFFExecutionId", item.ffExecutionId);
          this.$sessionsStorage.set("editFFBookingId", item.ffBookingId);
          if (item.stuffingType == "factoryStuffing") {
            this.$router.push({
              path: "/freightForward/newffExecution",
            });
          } else {
            this.$router.push({
              path: "/freightForward/newFFexecutionWareHouse",
            });
          }
        }
      } else if (item.isConsolidation == "1") {
        this.$sessionsStorage.set("editffFclConsoExportId", item.ffExportFclId);
        this.$sessionsStorage.set("editffConExecutionId", item.ffExecutionId);
        this.$sessionsStorage.set("editconFclBookingId", item.ffBookingId);
        this.$router.push({
          path: "/ffExportCon/executionWHStuffingIcdCon",
        });
      }
    },
    goPage(item) {
      if (item.isConsolidation == "0") {
        if (item.newContainerFlow == "1") {
          this.$sessionsStorage.set("editExportFCLId", item.ffExportFclId);
          this.$router.push({
            path: "/freightForward/newffExportFcl",
          });
        } else {
          this.$sessionsStorage.set("editExportFCLId", item.ffExportFclId);
          this.$router.push({
            path: "/freightForward/ffExportFcl",
          });
        }
      } else if (item.isConsolidation == "1") {
        this.$sessionsStorage.set("editffFclConsoExportId", item.ffExportFclId);
        this.$router.push({
          path: "/ffExportCon/ffExportFclConsolidation",
        });
      }
    },
    shouldBlink: function (item) {
      return item.CustomColorColumn === "red";
    },
    isBlinking: function (item) {
      return item.CustomColorColumn === "red";
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.getAssignmentPendencyList("Normal", "0", CURRENT, "2", event);
    },
    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getAssignmentPendencyList("Excell", "0", "0", "1", "1");
    },
    getAssignmentPendencyList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.JOBList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode:
          this.$route.path == "/conassignmentPendency"
            ? "checkConJobPendency"
            : "checkJobPendency",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        activeButtonBranch: this.activeButtonBranch,
        Filter: this.Filter,
      };

      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.JOBList.length > 0) {
                this.JOBList = data.JOBList;
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.JOBList.length > 0) {
                this.JOBList = data.JOBList;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on JOBList Error: ", error);
        });
    },

    filterClear() {
      this.filter = "";
      this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
    },

    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.currentPage = 1;
    },

    goBack() {
      window.history.go(-1);
    },
    clearTimeout() {},

    filterClear() {
      this.Filter = {
        userFilter: "",
      };
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
  },
};
</script>

<style>
.table-background thead {
  background-color: #a9e4ce;
  border-color: lightgrey;
  border-bottom-style: none;
  border-style: solid;
  border-width: 2px;
  height: 40px;
  position: sticky;
  top: 0;
  font-size: 11px;
}
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
.md-body-1,
.pendencyBody {
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.01em;
  line-height: 20px;
}

.table-background > tbody {
  font-size: 11px;
}

.table-background > thead {
  color: black;
}

.status-alerts {
  font-size: 18px;
  /* display: flex; */
  flex-direction: column;
  /* margin-bottom: 20px; */
}

.alert {
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  color: #fff;
}

.alert-danger-text {
  /* background-color: #d9534f; Bootstrap danger color */
  color: #d9534f; /* Bootstrap danger color */
}

.alert-info-text {
  color: #2a6fde;
  /* background-color: #2a6fde; Bootstrap danger color */
}

.alert-warning {
  background-color: #f0ad4e; /* Bootstrap warning color */
}

.alert strong {
  margin-right: 5px;
}

@keyframes blink2 {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.blink2 {
  animation: blink2 1s infinite; /* Adjust the duration as needed */
}
.blink {
  animation: blinker 1s linear infinite;
  font-weight: 800;
  color: red;
}
.blink-circle {
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  animation: blinker 6s linear infinite; /* 6 seconds for three color changes */
}
@keyframes blinker {
  0%,
  100% {
    background-color: red;
  }
  33% {
    background-color: green;
  }
  66% {
    background-color: blue;
  }
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// assignmentPendency.vue?1f11a1e2